import SubscriptionSelectionSummary from './SubscriptionSelectionSummary';

export default SubscriptionSelectionSummary;
